(function () {
  'use strict';

  angular.module('dwtModule').factory('QualificationLettersService', [
    '$http',
    'fileUploadSvc',
    function (
      $http,
      fileUploadSvc
    ) {
      return {
        list: function (pageNr, intermediaryUuid = null) {
          let url = `/v2/dwt/qualification-letters?pageNumber=${pageNr}`;
          if (intermediaryUuid) {
            url += `&intermediaryUuid=${intermediaryUuid}`;
          }
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: url,
            method: 'GET',
          });
        },
        create: function (reqData) {
          let formData = new FormData();
          formData.append('qualificationLetterNumber', reqData.qualificationLetterNumber);
          formData.append('rsin', reqData.rsin);
          formData.append('shareholderName', reqData.shareholderName);
          formData.append('validFrom', reqData.validFrom ? new Date(reqData.validFrom).toISOString() : null);
          formData.append('validTill', reqData.validTill ? new Date(reqData.validTill).toISOString() : null);
          if (reqData.intermediaryUuid) {
            formData.append('intermediaryUuid', reqData.intermediaryUuid);
          }
          formData.append('filename', reqData.filename);
          formData.append('file', reqData.file);

          return fileUploadSvc.uploadFileToUrl(
            reqData.file,
            '/v2/dwt/qualification-letters',
            formData
          );
        },

        delete: function (uuid) {
          return $http({
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            url: `/v2/dwt/qualification-letters/${uuid}`,
            method: 'DELETE',
          });
        },

      };
    },
  ]);
})();
